export function callBrowserUpdateScript() {
    window.$buoop = {
        required: { e: -1, i: -0, f: -4, o: -4, s: -1, c: -4 },
        insecure: true,
        api: 2025.11,
        noclose: true,
    };

    function $buo_f() {
        var e = document.createElement('script');
        e.src = '//browser-update.org/update.min.js';
        document.body.appendChild(e);
    };

    $buo_f();
}
